<div class="st-attachment-rename-header">{{ languageSettings.PSTWebAttachmentRenameModalTitle }}</div>
<mat-form-field
    subscriptSizing="dynamic"
    class="st-attachment-rename-body">
    <mat-label>{{ languageSettings.PSTWebAttachmentRenameModalInputLabel }} </mat-label>
    <input
        matInput
        required="true"
        [formControl]="attachmentName"
        [maxlength]="maxSymbols" />
    <span
        matSuffix
        class="st-attachment-rename-body--input-suffix"
        >{{ extension }}</span
    >
</mat-form-field>
<div class="st-attachment-rename-footer">
    <button
        mat-button
        class="st-attachment-rename-cancel-btn"
        color="secondary"
        (click)="cancel()">
        {{ languageSettings.PSTWebCancelButtonLabel }}
    </button>
    <button
        mat-raised-button
        color="primary"
        [disabled]="disabled"
        (click)="renameAttachment()">
        {{ languageSettings.PSTWebApplyButtonLabel }}
    </button>
</div>
